import React from 'react';

const Stepper = ({ step = 1 }) => {
    return (
        <ol className="flex items-centerfont-medium text-center text-gray-500 dark:text-gray-400 text-base w-90 py-6">
            <li className={`flex md:w-full items-center text-gray-500 dark:text-gray-400 sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}>
                <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
                    {step > 1 ? (
                        <i className="mr-2 fas fa-check-circle text-emerald-500" />
                    ) : (
                        <span className={`mr-2 ${step <= 1 ? 'font-bold' : ''}`}>1</span>
                    )}
                    <span className={`${step <= 1 ? 'font-bold' : ''}`}>Datos</span>
                </span>
            </li>
            <li className={`flex md:w-full items-center text-gray-500 dark:text-gray-400 after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700`}>
                <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
                    {step > 2 ? (
                        <i className="mr-2 fas fa-check-circle text-emerald-500" />
                    ) : (
                        <span className={`mr-2 ${step === 2 ? 'font-bold' : ''}`}>2</span>
                    )}
                    <span className={`${step === 2 ? 'font-bold' : ''}`}>Cargas</span>
                </span>
            </li>
            <li className={`flex items-center text-gray-500 dark:text-gray-400`}>
                {step > 3 ? (
                    <i className="mr-2 fas fa-check-circle text-emerald-500" />
                ) : (
                    <span className={`mr-2 ${step === 3 ? 'font-bold' : ''}`}>3</span>
                )}
                <span className={`${step === 3 ? 'font-bold' : ''}`}>Resultado</span>
            </li>
        </ol>
    );
};

export default Stepper;